import patternImage from "../../src/asset/Pattern.png";
export default function CTA() {
  return (
    <section className="bg-gradient-to-b from-[#0a0015] to-[#4916CF] py-20 px-6 text-center relative overflow-hidden">
      <div className="absolute top-10 right-20 opacity-20">
        <img src={patternImage} alt="" className="w-32 h-32" />
      </div>

      <div className="max-w-3xl mx-auto relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
          Secure. Trusted.
          <br />
          Reliable.
        </h2>
        <p className="text-white/70 mb-8">
          Experience the most secure and trusted platform for learning and
          engaging with blockchain technology
        </p>
      </div>
    </section>
  );
}
